import { getUserInfo} from '@/services/cookieService';


export function isAuthenticated() {
  const userInfo = getUserInfo();
  return !!userInfo.token;
}